import React from 'react';
import _ from 'lodash';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import Card from '../../../../shared/components/Card';
import CardHeader from '../../../../shared/components/card-header/CardHeader';
import CardBody from '../../../../shared/components/CardBody';
import Paginator from '../../../../shared/components/Paginator';
import { I18nUtils } from '../../../../../i18n/I18nUtils';
import HeaderSearchRefreshFilterOptions from '../../../../shared/components/HeaderSearchRefreshFilterOptions';
import Row from '../../../../shared/components/Row';
import * as tasksActions from '../actions/tasksActions';
import TasksTable from './TasksTable';
import TaskState from '../../../../shared/model/TaskState';
import StateManager from '../../../../shared/utils/StateManager';
import ConstructionAutocomplete from '../../../../shared/components/ConstructionAutocomplete';
import CompanyAutocomplete from '../../../../shared/components/CompanyAutocomplete';
import TaskDocumentsModal from './TaskDocumentsModal';
import TaskMonthlyModal from './TaskMonthlyModal';
import { TaskDateInput } from './TaskDateInput';

const INIT_SEARCH_FILTERS = {
    month: -1,
    year: -1,
    construction: null,
    company: null,
};

class TasksCard extends React.Component {

    STATE_MANAGER_KEY = 'TASKS_CARD';

    constructor(props) {
        super(props);

        this.onRefresh = this.onRefresh.bind(this);
        this.onSearch = this.onSearch.bind(this);
        this.onPage = this.onPage.bind(this);

        this.state = StateManager.getState(this.STATE_MANAGER_KEY, {
            filter: TaskState.PENDING_VALIDATION,
            date: '',
            ...INIT_SEARCH_FILTERS,
        });
    }

    componentWillMount() {
        if ( this.isAnyFilterSelected() ) {
            this.getTasks();
        }
        this.getTaskTypes();
    }

    componentDidUpdate(prevProps, prevState) {
        if ( this.isAnyFilterSelected() ) {
            if (
                prevState.search !== this.state.search ||
                prevState.filter !== this.state.filter ||
                prevState.page !== this.state.page ||
                prevState.construction !== this.state.construction ||
                prevState.year !== this.state.year ||
                prevState.month !== this.state.month ||
                prevState.company !== this.state.company
            ) {
                this.getTasks();
            }
        }
        StateManager.saveState(this.STATE_MANAGER_KEY, this.state);
    }

    isAnyFilterSelected() {
        const {
            month,
            year,
            construction,
            company,
        } = this.state;
        return (
            month !== INIT_SEARCH_FILTERS.month ||
            year !== INIT_SEARCH_FILTERS.year ||
            construction !== INIT_SEARCH_FILTERS.construction ||
            company !== INIT_SEARCH_FILTERS.company
        );
    }

    getTasks() {
        const filterOptions = {
            year: this.state.year,
            month: this.state.month,
            company_id: this.state.company ? this.state.company.id : null,
            construction_id: this.state.construction ? this.state.construction.id : null,
        };
        this.props.tasksActions.getTasks(this.state.page, this.state.search, this.state.filter, filterOptions);
    }

    getTaskTypes() {
        this.props.tasksActions.getTaskTypes();
    }

    onRefresh() {
        this.getTasks();
    }

    onSearch(search) {
        this.setState({ search: search, page: 1 });
    }

    onPage(page) {
        this.setState({ page });
    }

    handleSetMonth = (month) => {
        this.setState({ month });
    };

    handleSetYear = (year) => {
        this.setState({ year });
    };

    handleSetDate = (date) => {
        this.setState({ date });
    };

    getFilterOptions() {
        const filterOptions = this.props.tasksStates.map((taskState) => {
            return {
                id: taskState.id,
                title: taskState.name,
                active: taskState.id === this.state.filter,
                onClick: () => {
                    this.setState({ filter: taskState.id, page: 1 });
                },
            };
        });
        filterOptions.unshift({
            id: 0,
            title: I18nUtils.tr('TR_TODOS'),
            active: 0 === this.state.filter,
            onClick: () => {
                this.setState({ filter: 0, page: 1 });
            },
        });
        return filterOptions;
    }

    renderFilterName() {
        const states = _.keyBy(this.getFilterOptions(), 'id');
        if ( states && states[this.state.filter] ) {
            return states[this.state.filter].title;
        }
        return '';
    }

    renderHeaderOptions() {
        return (
            <HeaderSearchRefreshFilterOptions
                onRefresh={this.onRefresh}
                onSearch={this.onSearch}
                searchText={this.state.search}
                filterOptions={this.getFilterOptions()}
            />
        );
    }

    renderHeaderFilterOptions() {
        return (
            <div className="row">
                <div className="col-sm-4">
                    <label>Fecha:</label>
                    <div className="input-group m-b-0">
                        <div className="form-line">
                            <TaskDateInput handleSetMonth={this.handleSetMonth}
                                           handleSetYear={this.handleSetYear}
                                           handleSetDate={this.handleSetDate}
                                           date={this.state.date}
                            />
                        </div>
                    </div>
                </div>
                <div className="col-sm-4">
                    <label>Obra:</label>
                    <ConstructionAutocomplete
                        id={'TASK_CONSTRUCTION_AUTOCOMPLETE'}
                        construction={this.state.construction}
                        onChange={(value) => {
                            if ( value && value[0] ) {
                                this.setState({ construction: value[0], page: 1 });
                            } else {
                                this.setState({ construction: null, page: 1 });
                            }
                        }}
                    />
                </div>
                <div className="col-sm-4">
                    <label>Subcontrata:</label>
                    <CompanyAutocomplete
                        id={'TASK_COMPANY_AUTOCOMPLETE'}
                        company={this.state.company}
                        disabled={false}
                        onChange={(value) => {
                            if ( value && value[0] ) {
                                this.setState({ company: value[0], page: 1 });
                            } else {
                                this.setState({ company: null, page: 1 });
                            }
                        }}
                    />
                </div>
            </div>
        );
    }

    render() {
        const showSelectFiltersMessage = !this.isAnyFilterSelected();

        return (
            <Row clearfix>
                <Card loading={this.props.tasksLoading}>
                    <CardHeader
                        title={I18nUtils.tr('TR_TAREAS')}
                        subtitle={this.renderFilterName()}
                        rightOptions={this.renderHeaderOptions()}
                    />
                    <CardBody className="table-responsive">
                        <div>
                            {this.renderHeaderFilterOptions()}
                            <hr/>
                            <TasksTable
                                active={this.props.taskActive}
                                data={this.props.tasks}
                                error={this.props.tasksError}
                                showSelectFiltersMessage={showSelectFiltersMessage}
                            />
                        </div>
                        {!showSelectFiltersMessage &&
                            <Paginator onPage={this.onPage} data={this.props.tasksPagination}/>}
                    </CardBody>
                </Card>
                <TaskDocumentsModal
                    show={this.props.tasksDocumentsModal}
                    title={this.props.tasksDocumentsModalTitle}
                    subtitle={this.props.tasksDocumentsModalSubtitle}
                    date={this.props.tasksDocumentsModalDate}
                    build={this.props.tasksDocumentsModalBuild}
                    data={this.props.tasksDocuments}
                    error={this.props.tasksDocumentsError}
                    onHide={() => this.props.tasksActions.hideDocumentsDialog()}
                />
                <TaskMonthlyModal
                    show={this.props.tasksWorkChecksModal}
                    title={this.props.tasksWorkChecksModalTitle}
                    subtitle={this.props.tasksWorkChecksModalSubtitle}
                    date={this.props.tasksWorkChecksModalDate}
                    build={this.props.tasksWorkChecksModalBuild}
                    onHide={() => this.props.tasksActions.hideWorkCheckDialog()}
                />
            </Row>
        );
    }
}

const mapStateToProps = (state, ownProps) => {

    return {
        tasks: state.tasks.tasks,
        tasksPagination: state.tasks.tasksPagination,
        tasksLoading: state.tasks.tasksLoading,
        tasksError: state.tasks.tasksError,

        tasksStates: state.tasks.taskStates,

        taskActive: state.tasks.taskActive,

        tasksDocumentsModal: state.tasks.tasksDocumentsModal,
        tasksDocumentsModalTitle: state.tasks.tasksDocumentsModalTitle,
        tasksDocumentsModalSubtitle: state.tasks.tasksDocumentsModalSubtitle,
        tasksDocumentsModalDate: state.tasks.tasksDocumentsModalDate,
        tasksDocumentsModalBuild: state.tasks.tasksDocumentsModalBuild,
        tasksDocuments: state.tasks.tasksDocuments,
        tasksDocumentsError: state.tasks.tasksDocumentsError,

        tasksWorkChecksModal: state.tasks.tasksWorkChecksModal,
        tasksWorkChecksModalTitle: state.tasks.tasksWorkChecksModalTitle,
        tasksWorkChecksModalSubtitle: state.tasks.tasksWorkChecksModalSubtitle,
        tasksWorkChecksModalDate: state.tasks.tasksWorkChecksModalDate,
        tasksWorkChecksModalBuild: state.tasks.tasksWorkChecksModalBuild,
    };
};

const mapDispatchToProps = dispatch => ( {
    tasksActions: bindActionCreators(tasksActions, dispatch),
} );

export default connect(mapStateToProps, mapDispatchToProps)(TasksCard);

TasksCard.propTypes = {};

TasksCard.defaultProps = {};



// WEBPACK FOOTER //
// ./src/app/my-outsources/tasks/list/components/TasksCard.js